<template>
  <div class="dashboard">
    <SideNav v-bind:page_active="page_active" />

    <div class="main-section">
      <TopNav />

      <div class="heading-lead h5 bg-white">
        <b>Sales Order</b>
      </div>

      <div class="content-body" style="padding-top: 5px">
        <div class="row filter-wrap mb-3">
          <div class="col-lg-12">
            <ul class="nav nav-tab">
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="order_tab_active == 'PENDING' ? 'active' : ''"
                  @click="order_tab_active = 'PENDING'"
                  aria-current="page"
                  href="#"
                  >Pending Orders</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="order_tab_active == 'MODIFIED' ? 'active' : ''"
                  @click="order_tab_active = 'MODIFIED'"
                  aria-current="page"
                  href="#"
                  >Modified Orders</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="order_tab_active == 'Backorder' ? 'active' : ''"
                  @click="order_tab_active = 'Backorder'"
                  aria-current="page"
                  href="#"
                  >Open Orders</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="order_tab_active == 'Invoiced' ? 'active' : ''"
                  @click="order_tab_active = 'Invoiced'"
                  aria-current="page"
                  href="#"
                  >Invoiced Orders</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="order_tab_active == 'Rejected' ? 'active' : ''"
                  @click="order_tab_active = 'Rejected'"
                  aria-current="page"
                  href="#"
                  >Rejected Orders</a
                >
              </li>
              <!-- <li class="nav-item">
                                <a class="nav-link" :class="order_tab_active == 'Canceled' ? 'active' : ''"  @click="order_tab_active = 'Canceled'" aria-current="page" href="#">Canceled Orders</a>
                            </li> -->
            </ul>
          </div>

          <div class="col-lg-12">
            <div
              class="p-4"
              style="border: 1px solid #dee2e6; border-top: none"
              v-if="order_tab_active == 'PENDING'"
            >
              <table
                class="table table-striped table-hover"
                v-if="order_tab_active != 'MODIFIED'"
              >
                <thead>
                  <tr style="border-bottom: 2px solid #000">
                    <th>SN</th>
                    <th style="width: 200px">Order ID</th>
                    <!-- <th>Sub Total</th> -->
                    <!-- <th>Freight  Charge</th> -->
                    <th style="width: 85px; text-align: center">AMOUNT</th>

                    <!-- <th>Total Items Method Location</th> -->
                    <th>Delivery</th>
                    <th>Site</th>
                    <!-- <th>Delivery Address</th> -->
                    <th>Date</th>
                    <th>Time</th>
                    <!-- <th>Status</th> -->
                    <th scope="col" style="width: 20px">Action</th>
                  </tr>
                </thead>

                <tbody v-if="isOpen">
                  <tr v-for="(x, i) in oms_pending_list" :key="i">
                    <td></td>
                    <td>{{ x.order_no }}</td>
                    <td class="text-end">
                      &#x20A6;{{
                        thDFormat(Number(x.amount) + Number(x.freighted_charge))
                      }}
                    </td>
                    <!-- <td>&#x20A6;{{ thDFormat(Number(x.amount)) }}</td> -->
                    <!-- <td>&#x20A6;{{ thDFormat(Number(x.freighted_charge)) }}</td> -->
                    <!-- <td>{{x.order_items_count}} Item(s)</td> -->

                    <td>{{ x.colection_methodID }}</td>
                    <td>{{ x.loading_locationID }}</td>
                    <!-- <td>{{x.ship_address}}</td> -->
                    <td>{{ formatDate(x.date_created, "date") }}</td>
                    <td>{{ formatDate(x.date_created, "time") }}</td>
                    <!-- <td>{{x.order_status}}</td> -->
                    <td>
                      <a
                        href="#!"
                        @click="view_index3 = i"
                        class="d-block btn-sm font-12 btn btn-success"
                        data-bs-toggle="modal"
                        data-bs-target="#filterModal4"
                        >View</a
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td style="display:none"></td>
                    <td colspan="8" class="text-center">No data available</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              class="modal fade"
              id="filterModal4"
              tabindex="-1"
              aria-labelledby="exampleModalLabe4"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content shadow-sm">
                  <div class="modal-header">
                    <h5
                      class="modal-title color-scope bolder"
                      id="exampleModalLabel"
                    >
                      Order Line Items
                    </h5>

                    <button
                      type="button"
                      class="btn-close"
                      id="closebtn"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <p
                      v-if="oms_pending_list[view_index3].ship_address"
                      class="font-12"
                    >
                      Delivery Address:
                      {{ oms_pending_list[view_index3].ship_address }}
                    </p>

                    <table class="table table-striped table-hover">
                      <thead>
                        <tr>
                          <td>Item No</td>
                          <td>Product Name</td>
                          <!-- <td>Unit</td> -->
                          <td>Unit Price</td>
                          <td>Quantity</td>
                          <!-- <td>Suggested Quantity</td> -->
                          <td>Price</td>
                          <!-- <td>Site</td> -->
                          <!-- <td>Line Status</td> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(p, j) in oms_pending_list[view_index3]
                            .order_items"
                          :key="j"
                        >
                          <td>{{ p.productID }}</td>
                          <td>{{ p["products"].productname }}</td>
                          <!-- <td> {{p.unit}}</td> -->
                          <td>&#x20A6;{{ thDFormat(Number(p.price)) }}</td>
                          <td>
                            {{ thDFormat(Number(p.quantity)) }} {{ p.unit }}
                          </td>
                          <!-- <td> {{ thDFormat(p.suggested_quantity) }}</td> -->
                          <td>&#x20A6;{{ thDFormat(Number(p.amount)) }}</td>
                          <!-- <td> {{p.site}}</td> -->
                          <!-- <td> {{p.linestatus}}</td> -->
                        </tr>
                      </tbody>
                    </table>

                    <!-- <button class="btn btn-success btn-large text-end" @click="changeModify(oms_order_list[view_index].ID,'APPROVED')" style="margin-right:10px"  data-bs-dismiss="modal" aria-label="Close">Approve</button>
                                        <button class="btn btn-danger btn-large text-end" @click="changeModify(oms_order_list[view_index].ID,'REJECTED')" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
                                        -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- list from ORM modified -->
          <div class="col-lg-12">
            <div class="" style="" v-if="order_tab_active == 'MODIFIED'">
              <table
                class="table table-striped table-hover"
                v-if="order_tab_active != 'PENDING'"
              >
                <thead>
                  <tr style="border-bottom: 2px solid #000">
                    <th>SN</th>
                    <th>Order ID</th>
                    <th>AMOUNT</th>
                    <!-- <th>Sub Total</th> -->
                    <!-- <th>Freighted Charge</th> -->
                    <!-- <th>Total Items</th> -->
                    <th>Delivery</th>
                    <th>Site</th>
                    <!-- <th>Delivery Address</th> -->
                    <th>Date</th>
                    <th>Time</th>
                    <!-- <th>Updated Date</th> -->
                    <!-- <th>Status</th> -->

                    <th scope="col" style="width: 20px">Action</th>
                  </tr>
                </thead>
                <tbody v-if="isOpen1">
                  <tr v-for="(x, i) in oms_order_list" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ x.order_no }}</td>
                    <td>
                      &#x20A6;{{
                        thDFormat(Nummber(x.amount) + Number(x.freighted_charge))
                      }}
                    </td>
                    <!-- <td>&#x20A6;{{ thDFormat(Number(x.amount)) }}</td> -->
                    <!-- <td>&#x20A6;{{ thDFormat(Number(x.freighted_charge)) }}</td> -->
                    <!-- <td>{{x.order_items_count}} Item(s)</td> -->

                    <td>{{ x.colection_methodID }}</td>
                    <td>{{ x.loading_locationID }}</td>
                    <!-- <td>{{x.ship_address}}</td> -->
                    <!-- <td>{{x.date_created}}</td> -->
                    <!-- <td>{{x.updated_at}}</td> -->
                    <td>{{ formatDate(x.updated_at, "date") }}</td>
                    <td>{{ formatDate(x.updated_at, "time") }}</td>
                    <!-- <td>{{x.order_status}}</td> -->
                    <td>
                      <a
                        href="#!"
                        @click="view_index = i"
                        class="d-block btn-sm font-12 btn btn-success"
                        data-bs-toggle="modal"
                        data-bs-target="#filterModal3"
                        >View</a
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td style="display:none"></td>
                    <td colspan="8" class="text-center">No data available</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- modified order item from OMS -->
            <div
              class="modal fade"
              id="filterModal3"
              tabindex="-1"
              aria-labelledby="exampleModalLabe3"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content shadow-sm">
                  <div class="modal-header">
                    <h5
                      class="modal-title color-scope bolder"
                      id="exampleModalLabel"
                    >
                      Order Line Items
                    </h5>

                    <button
                      type="button"
                      class="btn-close"
                      id="closebtn"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <table class="table table-striped table-hover">
                      <thead>
                        <tr>
                          <td>S/N</td>
                          <td>Item No</td>
                          <td>Product Name</td>
                          <td>Suggested Product</td>
                          <td>Unit Price</td>
                          <td>Suggested Unit Price</td>
                          <td>Ordered Quantity</td>
                          <td>Suggested Quantity</td>
                          <td>Unit</td>
                          <td>Reason</td>
                          <td>Modification Type</td>
                          <td>Suggested Total</td>
                          <!-- <td>Price</td> -->
                          <!-- <td>Site</td> -->
                          <!-- <td>Line Status</td> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(p, j) in oms_order_list[view_index]
                            .order_items"
                          :key="j"
                          :style="p.modificationtype ? 'background:yellow' : ''"
                        >
                          <td></td>
                          <td>{{ p.productID }}</td>
                          <td>{{ p["products"].productname }}</td>

                          <td>
                            {{
                              p["modifyproducts"]
                                ? p["modifyproducts"].productname
                                : ""
                            }}
                          </td>

                          <td>&#x20A6;{{ thDFormat(Number(p.price)) }}</td>
                          <td>
                            &#x20A6;{{ thDFormat(Number(p.suggested_price)) }}
                          </td>

                          <td>
                            {{ thDFormat(Number(p.quantity)) }}
                            ({{
                              thDFormat(p.quantity / p["products"].bagcount)
                            }}
                            tonne
                            <span v-if="p.quantity / p['products'].bagcount > 1"
                              >s</span
                            >)
                          </td>

                          <td>
                            <span v-if="p.suggested_quantity">
                              {{ Number(p.suggested_quantity) }}

                              ({{
                                p.suggested_quantity / p["products"].bagcount
                              }}

                              tonne<span
                                v-if="
                                  p.suggested_quantity /
                                    p['products'].bagcount >
                                    1
                                "
                                >s</span
                              >)
                            </span>

                            <span v-if="!p.suggested_quantity">
                              {{ Number(p.quantity) }}

                              ({{
                                p.quantity / p["products"].bagcount
                              }}
                              tonne<span
                                v-if="p.quantity / p['products'].bagcount > 1"
                                >s</span
                              >)
                            </span>
                          </td>

                          <td>{{ p.unit }}</td>
                          <td>{{ p.reason }}</td>

                          <td>
                            {{
                              p.modificationtype == "quantitychange"
                                ? "quantity updated"
                                : p.modificationtype == "productchange"
                                ? "Product replaced"
                                : ""
                            }}
                          </td>

                          <td>
                            <span v-if="p.suggested_quantity">
                              &#x20A6;{{
                                thDFormat(
                                  Number(p.suggested_quantity) *
                                    (p.modificationtype == "quantitychange"
                                      ? Number(p.price)
                                      : Number(p.suggested_price)),
                                )
                              }}
                            </span>
                            <span v-else>
                              &#x20A6;{{ thDFormat(p.quantity * p.price) }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      <thead>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td style="width: 150px">
                            Suggested Freighted Charge
                          </td>

                          <td style="text-align: right">
                            &#x20A6;{{
                              oms_order_list[view_index].colection_methodID ==
                              "freighted"
                                ? thDFormat(
                                    Number(
                                      oms_order_list[view_index]
                                        .suggested_freighted,
                                    ),
                                  )
                                : 0
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td style="width: 150px">Suggested Sub Total</td>

                          <td style="text-align: right">
                            &#x20A6;{{
                              oms_order_list[view_index].order_items.length > 0
                                ? thDFormat(
                                    oms_order_list[view_index].order_items
                                      .map(
                                        (x) =>
                                          (x.modificationtype == "productchange"
                                            ? x.suggested_price
                                            : x.price) *
                                          (x.suggested_quantity
                                            ? x.suggested_quantity
                                            : x.quantity),
                                      )
                                      .reduce((p, v) => Number(p) + Number(v)),
                                  )
                                : 0
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td style="width: 150px">Suggested Grand Total</td>

                          <td style="text-align: right">
                            &#x20A6;{{
                              oms_order_list[view_index].order_items.length > 0
                                ? thDFormat(
                                    oms_order_list[view_index].order_items
                                      .map(
                                        (x) =>
                                          (x.modificationtype == "productchange"
                                            ? x.suggested_price
                                            : x.price) *
                                          (x.suggested_quantity
                                            ? x.suggested_quantity
                                            : x.quantity),
                                      )
                                      .reduce((p, v) => Number(p) + Number(v)) +
                                      Number(
                                        oms_order_list[view_index]
                                          .suggested_freighted,
                                      ),
                                  )
                                : 0
                            }}
                          </td>
                        </tr>
                      </thead>
                    </table>

                    <button
                      class="btn btn-success btn-large text-end"
                      @click="
                        changeModify(oms_order_list[view_index].ID, 'APPROVED')
                      "
                      style="margin-right: 10px"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Accept
                    </button>
                    <button
                      class="btn btn-danger btn-large text-end"
                      @click="
                        changeModify(oms_order_list[view_index].ID, 'REJECTED')
                      "
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      style="margin-right: 10px"
                    >
                      Cancel
                    </button>
                    <button
                      class="btn btn-info btn-large text-end text-white"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <div
              class="p-4"
              style="border: 1px solid #dee2e6; border-top: none"
              v-if="order_tab_active == 'Rejected'"
            >
              <table class="table table-striped table-hover">
                <thead>
                  <tr style="border-bottom: 2px solid #000">
                    <th>SN</th>
                    <th style="width: 200px">Order ID</th>
                    <th style="width: 85px; text-align: center">AMOUNT</th>
                    <th>Delivery</th>
                    <th>Site</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th scope="col" style="width: 20px">Action</th>
                  </tr>
                </thead>
                <tbody v-if="isOpenRejected">
                  <tr v-for="(x, i) in oms_rejected_list" :key="i">
                    <td></td>
                    <td>{{ x.order_no }}</td>
                    <td class="text-end">
                      &#x20A6;{{
                        thDFormat(Number(x.amount) + Number(x.freighted_charge))
                      }}
                    </td>
                    <td>{{ x.colection_methodID }}</td>
                    <td>{{ x.loading_locationID }}</td>
                    <td>{{ formatDate(x.date_created, "date") }}</td>
                    <td>{{ formatDate(x.date_created, "time") }}</td>
                    <td>
                      <a
                        href="#!"
                        @click="view_index_rejected = i"
                        class="d-block btn-sm font-12 btn btn-success"
                        data-bs-toggle="modal"
                        data-bs-target="#filterModalRejected"
                        >View</a
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td style="display:none"></td>
                    <td colspan="8" class="text-center">No data available</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="modal fade"
              id="filterModalRejected"
              tabindex="-1"
              aria-labelledby="exampleModalLabelRejected"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content shadow-sm">
                  <div class="modal-header">
                    <h5
                      class="modal-title color-scope bolder"
                      id="exampleModalLabelRejected"
                    >
                      Order Line Items
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      id="closebtnRejected"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <template v-if="oms_rejected_list[view_index_rejected]">
                      <p
                        v-if="
                          oms_rejected_list[view_index_rejected].ship_address
                        "
                        class="font-12"
                      >
                        Delivery Address:
                        {{
                          oms_rejected_list[view_index_rejected].ship_address
                        }}
                      </p>

                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <td>Item No</td>
                            <td>Product Name</td>
                            <td>Unit Price</td>
                            <td>Quantity</td>
                            <td>Price</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(p, j) in oms_rejected_list[
                              view_index_rejected
                            ].order_items || []"
                            :key="j"
                          >
                            <td>{{ p.productID }}</td>
                            <td>
                              {{
                                p["products"]
                                  ? p["products"].productname
                                  : p.productname || ""
                              }}
                            </td>
                            <td>&#x20A6;{{ thDFormat(Number(p.price)) }}</td>
                            <td>
                              {{ thDFormat(Number(p.quantity)) }} {{ p.unit }}
                            </td>
                            <td>&#x20A6;{{ thDFormat(Number(p.amount)) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                    <p v-else class="text-center">No data available</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- list from AX -->
          <div class="col-lg-12">
            <div
              class="filter-area"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <span>
                <svg
                  width="33"
                  height="33"
                  style="margin-right: 30px; top: 0px"
                  viewBox="0 0 38 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.8333 28.5H22.1667V25.3333H15.8333V28.5ZM4.75 9.5V12.6667H33.25V9.5H4.75ZM9.5 20.5833H28.5V17.4167H9.5V20.5833Z"
                    fill="#006E40"
                  />
                </svg>
              </span>
              <small> Filter </small>
            </div>

            <!-- search - filter order from AX -->
            <div
              class="modal fade"
              id="filterModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content shadow-sm">
                  <div class="modal-header">
                    <h5
                      class="modal-title color-scope bolder"
                      id="exampleModalLabel"
                    >
                      Filter
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      id="closebtn"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <p class="bolder mb-3 mt-5">Select date range</p>

                    <div class="row">
                      <div class="col-12">
                        <input
                          type="date"
                          v-model="startdate"
                          class="form-control border-b"
                          style="height: 55px"
                        />
                      </div>
                      <div class="col-12 mt-3">
                        <input
                          type="date"
                          v-model="enddate"
                          class="form-control border-b"
                          style="height: 55px"
                        />
                      </div>

                      <div class="col-12 mt-3">
                        <button
                          type="button"
                          @click="filterResult()"
                          class="btn scope-bg btn-success col-12"
                          style="height: 55px"
                        >
                          Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="" style="" v-if="order_tab_active == 'Backorder'">
              <table class="table table-striped table-hover">
                <thead>
                  <tr style="border-bottom: 2px solid #d8d8d8">
                    <th>S/N</th>
                    <th>order ID</th>
                    <th>Date</th>
                    <th>Delivery Terms</th>
                    <th>Delivery Address</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="order_list.length > 0">
                  <tr v-for="(x, i) in order_list" :key="i">
                    <td></td>
                    <td>{{ x.SalesOrderNumber }}</td>
                    <td>{{ formatDate(x.OrderCreationDateTime, "date") }}</td>
                    <td>
                      {{
                        x.DeliveryTermsCode == "CFR"
                          ? "FMN Delivery"
                          : "Self Collection"
                      }}
                    </td>
                    <td>{{ x.DeliveryAddressStreet || "--" }}</td>
                    <td>
                      <button
                        class="d-block btn-sm font-12 btn btn-success"
                        @click="view_index2 = i"
                        data-bs-toggle="modal"
                        data-bs-target="#filterModal2"
                      >
                        View
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="" style="" v-if="order_tab_active == 'Invoiced'">
              <table class="table table-striped table-hover">
                <thead>
                  <tr style="border-bottom: 2px solid #d8d8d8">
                    <th>S/N</th>
                    <th>order ID</th>
                    <th>Date</th>
                    <th>Delivery Terms</th>
                    <th>Delivery Address</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="Invoiced_list.length > 0">
                  <tr v-for="(x, i) in Invoiced_list" :key="i">
                    <td></td>
                    <td>{{ x.SalesOrderNumber }}</td>
                    <td>{{ formatDate(x.OrderCreationDateTime, "date") }}</td>
                    <td>
                      {{
                        x.DeliveryTermsCode == "CFR"
                          ? "FMN Delivery"
                          : "Self Collection"
                      }}
                    </td>
                    <td>{{ x.DeliveryAddressStreet || "--" }}</td>

                    <!-- <td>
                                            <button style="border:none; color:blue; font-size:13px; font-weight:600" @click="view_indexInvoiced = i"  data-bs-toggle="modal" data-bs-target="#filterModalInvoiced">Confirm Delivery</button>
                                        </td> -->

                    <td>
                      <button
                        class="d-block btn-sm font-12 btn btn-success"
                        @click="view_indexInvoiced = i"
                        data-bs-toggle="modal"
                        data-bs-target="#filterModalInvoiced"
                      >
                        Open
                      </button>
                    </td>

                    <!-- <td style="text-align: center;">
                                            <span v-if="x.salesorderline[0].SalesOrderLineStatus != 'Delivered'">
                                                <span v-if="x.salesorderline[0].SalesOrderLineStatus == 'Canceled'">
                                                    Canceled
                                                </span>
                                                <span v-else>
                                                    <span v-if="x.podstatus != ''">
                                                        <span v-if="x.podstatus == 1">
                                                            Delivered
                                                        </span>
                                                        <span v-else>                                                    
                                                            <a href="#!" @click="confirmPOD(x.orderID);" class="d-block btn-sm font-12 btn btn-success" title='Click to approve proof of delivery' style="font-size: 10px; padding: 3px 0px;">Confirm Delivery</a>
                                                        </span>
                                                    </span>
                                                    <span v-else>
                                                        Pending
                                                    </span>                                                
                                                </span>
                                            </span>                                            
                                            <span v-else>
                                                {{x.salesorderline[0].SalesOrderLineStatus}}
                                            </span>
                                        </td> -->

                    <!-- <td>
                                            <u v-if="x.deliveryterms == 'CFR'">
                                                <span v-if="x.salesorderline[0].linestatus == 'Invoiced'" target="blank" class="d-block color-scope">
                                                    <a v-if="x.tracking_link != ''" :href="x.tracking_link">Track</a>
                                                    <span v-else  @click="$swal.fire('Alert','No Tracking Available', 'error')" >Track</span>
                                                </span>
                                            </u>
                                            
                                            <u v-if="x.deliveryterms == 'CFR'">
                                                <span v-if="x.salesorderline[0].linestatus == 'Invoiced'" target="blank" class="d-block color-scope">
                                                    <a v-if="x.tracking_link != ''" :href="x.tracking_link">Proof of delivery</a>
                                                </span>
                                            </u>
                                        </td> -->
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td style="display:none"></td>
                    <td colspan="8" class="text-center">No data available</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- order item from AX -->
            <div
              class="modal fade"
              id="filterModal2"
              tabindex="-1"
              aria-labelledby="exampleModalLabe2"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content shadow-sm">
                  <div class="modal-header">
                    <h5
                      class="modal-title color-scope bolder"
                      id="exampleModalLabel"
                    >
                      Order Line Items
                    </h5>

                    <button
                      type="button"
                      class="btn-close"
                      id="closebtn"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <table class="table table-striped table-hover">
                      <thead>
                        <tr>
                          <td>S/N</td>
                          <td>Item No</td>
                          <td>Product Name</td>
                          <td>Unit Price</td>
                          <td>Quantity</td>
                          <td>Price</td>
                          <td>Site</td>
                          <!-- <td style="width:90px">Line Status</td> -->
                        </tr>
                      </thead>
                      <tbody v-if="order_list.length > 0">
                        <tr
                          v-for="(p, j) in order_list[view_index2]
                            .SalesOrderLines"
                          :key="j"
                        >
                          <td></td>
                          <td>{{ p.ItemNumber }}</td>
                          <td>{{ p.LineDescription }}</td>
                          <td>&#x20A6;{{ thDFormat(Number(p.SalesPrice)) }}</td>
                          <td>
                            {{ thDFormat(Number(p.OrderedSalesQuantity)) }}
                          </td>
                          <td>&#x20A6;{{ thDFormat(Number(p.LineAmount)) }}</td>
                          <td>{{ p.ShippingSiteId }}</td>
                          <!-- <td> {{p.SalesOrderLineStatus == 'Backorder' ? 'Open Order' : p.SalesOrderLineStatus}}</td> -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- order item from AX -->
            <div
              class="modal fade"
              id="filterModalInvoiced"
              tabindex="-1"
              aria-labelledby="exampleModalLabe2"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content shadow-sm">
                  <div class="modal-header">
                    <h5
                      class="modal-title color-scope bolder"
                      id="exampleModalLabel"
                    >
                      Ivoiced Items {{ view_indexInvoiced }}
                    </h5>

                    <button
                      type="button"
                      class="btn-close"
                      id="closebtn"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <table class="table table-striped table-hover">
                      <thead v-if="Invoiced_list.length > 0">
                        <tr>
                          <td>S/N</td>
                          <td>Item No</td>
                          <td>Product Name</td>
                          <td>Unit Price</td>
                          <td>Quantity</td>
                          <td>Price</td>
                          <td>Site</td>
                          <td
                            v-if="
                              Invoiced_list[view_indexInvoiced]
                                .DeliveryTermsCode == 'CFR' &&
                                Invoiced_list[view_indexInvoiced]
                                  .podsubmitted != 1
                            "
                            style="width: 90px"
                          >
                            Damaged Products
                          </td>
                        </tr>
                      </thead>
                      <tbody v-if="Invoiced_list.length > 0">
                        <tr
                          v-for="(p, j) in Invoiced_list[view_indexInvoiced]
                            .SalesOrderLines"
                          :key="j"
                        >
                          <td></td>
                          <td>{{ p.ItemNumber }}</td>
                          <td>{{ p.LineDescription }}</td>
                          <td>&#x20A6;{{ thDFormat(Number(p.SalesPrice)) }}</td>
                          <td>
                            {{ thDFormat(Number(p.OrderedSalesQuantity)) }}
                          </td>
                          <td>&#x20A6;{{ thDFormat(Number(p.LineAmount)) }}</td>
                          <td>{{ p.ShippingSiteId }}</td>
                          <td
                            v-if="
                              Invoiced_list[view_indexInvoiced]
                                .DeliveryTermsCode == 'CFR' &&
                                Invoiced_list[view_indexInvoiced]
                                  .podsubmitted != 1
                            "
                          >
                            <input
                              placeholder="Enter value"
                              v-model="p.damagedQty"
                            />
                          </td>
                          <!-- <td> {{p.SalesOrderLineStatus == 'Backorder' ? 'Open Order' : p.SalesOrderLineStatus}}</td> -->
                        </tr>
                      </tbody>
                    </table>

                    <div
                      v-if="
                        Invoiced_list.length > 0 &&
                          Invoiced_list[view_indexInvoiced].podsubmitted != 1
                      "
                    >
                      <button
                        v-if="
                          Invoiced_list[view_indexInvoiced].DeliveryTermsCode ==
                            'CFR'
                        "
                        data-bs-dismiss="modal"
                        @click="confirmPOD(Invoiced_list[view_indexInvoiced])"
                        class="btn"
                        style="background: green; color: #fff; float: right"
                      >
                        Confrim Delivery
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Copyright />
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from "@/components/SideNav.vue";
import Copyright from "@/components/Copyright.vue";
import TopNav from "@/components/TopNav.vue";
import moment from "moment";

import axios from "axios";

export default {
  name: "Orders",
  components: {
    SideNav,
    TopNav,
    Copyright,
  },

  data() {
    return {
      page_active: "orders",

      order_list: [
        // {
        //     "salesorderline":[
        //         {"linestatus":"", "unitprice":"", "price":"", "itemno":"", "productname":"","unit":"","quantity":"", "site":""}
        //     ]
        // }
      ],

      Invoiced_list: [
        // {
        //     "salesorderline":[
        //         {"linestatus":"", "unitprice":"", "price":"", "itemno":"", "productname":"","unit":"","quantity":"", "site":""}
        //     ]
        // }
      ],

      obj_order: {},

      subaccountid: "",
      currentBalance: "",
      creditRemaining: "",
      avaiableBalance: "",
      sub_acct: "",
      order_set: "",
      theorder: "",

      startdate: "",
      enddate: "",
      nodata: 0,
      view_index: 0,
      view_index2: 0,
      view_indexInvoiced: 0,
      view_index3: 0,
      order_tab_active: "Backorder",
      oms_rejected_list: [{ order_items: [] }],
      oms_order_list: [{ order_items: [] }],
      oms_pending_list: [{ order_items: [] }],
      isOpen: false,
      isOpen1: false,
      isOpen2: false,
      isOpenRejected: false,
      oms_rejected_total: 0,
      view_index_rejected: 0,
      pod: {},
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        document.title = "FMN | Dashboard";
      },
    },
  },

  mounted() {
    this.inactivityTime();
    if (this.$store.getters.vendor_no) {
      this.phone = this.$store.getters.phone;
      this.vendor_no = this.$store.getters.vendor_no;
      this.sub_acct = this.$store.getters.sub_acct;
    }

    this.obj_order.startdate = moment()
      .subtract(2, "months")
      .format("YYYY/MM/DD");
    this.obj_order.enddate = moment()
      .add(1, "days")
      .format("YYYY/MM/DD");

    this.getSalesOrdersBackorders(); // load sales order history from AX
    this.getSalesOrdersInvoiced(); // load sales order history from AX
    this.getOMSOrders(); // load sales order history from
    this.getPendingOrders(); // load sales order history from
    this.getRejectedOrders(); // load sales order history from
    // this.fetchAccountBalance();
  },

  methods: {
    // # fn() to return AX balance for selected account;
    // # purpose for credit limit check;
    fetchAccountBalance() {
      let data = this.loadNew({
        vendor_no: this.$store.getters.vendor_no,
        primary_legal_entity: this.$store.getters.entity,
      });
      axios({
        method: "get",
        url: this.$hostname + "/get-accounts-by-legal-entity",
        headers: {
          "Content-Type": "application/json",
          "X-Request-IV": data.iv,
          Authorization: `Bearer ${this.$store.getters.headerstoken}`,
        },
        params: { token: data.cipher },
      })
        .then((res) => {
          if (res.data.status == true) {
            // # prepare server response
            this.$store.commit("set_subaccounts", res.data.data);
            let sub_acct = this.$store.getters.sub_acct;
            let currentacc = res.data.data.filter(
              (el) => el.CustomerAccount == sub_acct,
            );

            let account_balance = currentacc[0].CreditRemaining;

            // store current in lDB
            this.$store.commit("set_sub_acct_bal", account_balance);
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.is401(error.response.status);
          }
        });
    },

    async getSalesOrdersInvoiced() {
      this.$swal.fire({
        title: "",
        html: this.$preloader,
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false,
      });
      this.obj_order.subaccountID = this.sub_acct;

      this.obj_order.page = 1;
      this.obj_order.pagesize = 100;
      this.obj_order.linestatus = "Invoiced";
      this.obj_order.subaccountID = this.$store.getters.sub_acct;
      this.obj_order.primary_legal_entity = this.$store.getters.entity;

      console.log(this.obj_order);
      let data = this.loadNew(this.obj_order);
      try {
        await axios({
          method: "post",
          url: this.$hostname + "/get-all-sale-order-transactions",
          data: { token: data.cipher },
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
        })
          .then((res) => {
            console.log(res);
            if (res.data.data.length > 0) {
              this.Invoiced_list = res.data.data;
              // this.reverseSort('date');
            }

            // if(res.data.data.length == 0){
            //      this.nodata2 = true;
            // }

            this.$swal.close();
          })

          .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
              this.is401(error.response.status);
            }
          });
      } catch (err) {
        console.log(err);
      }
    },

    async getSalesOrdersBackorders() {
      this.$swal.fire({
        title: "",
        html: this.$preloader,
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false,
      });
      this.obj_order.subaccountID = this.sub_acct;

      this.obj_order.page = 1;
      this.obj_order.pagesize = 100;
      this.obj_order.linestatus = "Backorder";
      this.obj_order.subaccountID = this.$store.getters.sub_acct;
      this.obj_order.primary_legal_entity = this.$store.getters.entity;

      let data = this.loadNew(this.obj_order);
      try {
        await axios({
          method: "post",
          url: this.$hostname + "/get-all-sale-order-transactions",
          data: { token: data.cipher },
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
        })
          .then((res) => {
            console.log(res);
            if (res.data.data.length > 0) {
              this.order_list = res.data.data;
              // this.reverseSort('date');
            }
            this.$swal.close();
          })

          .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
              this.is401(error.response.status);
            }
          });
      } catch (err) {
        console.log(err);
      }
    },

    async getOMSOrders() {
      try {
        let data = this.loadNew({
          status: "MODIFIED",
          sub_accountID: this.sub_acct,
          subaccountID: this.$store.getters.sub_acct,
          primary_legal_entity: this.$store.getters.entity,
        });
        await axios({
          method: "get",
          url: this.$hostname + "/modify-sales-order",
          params: { token: data.cipher },
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
        })
          .then((res) => {
            if (res.data.data.data.length > 0) {
              this.isOpen1 = true;
              this.oms_order_list = res.data.data.data;

              this.oms_updated_total = parseFloat(
                res.data.data.data
                  .map((x) => x.amount)
                  .reduce((p, v) => Number(p) + Number(v)) +
                  res.data.data.data
                    .map((x) => x.freighted_charge)
                    .reduce((p, v) => Number(p) + Number(v)),
              );
            }
          })

          .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
              this.is401(error.response.status);
            }
          });
      } catch (err) {
        console.log(err);
      }
    },

    async getPendingOrders() {
      try {
        let data = this.loadNew({
          status: "PENDING",
          sub_accountID: this.sub_acct,
          subaccountID: this.$store.getters.sub_acct,
          primary_legal_entity: this.$store.getters.entity,
        });
        await axios({
          method: "get",
          url: this.$hostname + "/modify-sales-order",
          params: { token: data.cipher },
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
        })
          .then((res) => {
            if (res.data.data.data.length > 0) {
              this.isOpen = true;
              this.oms_pending_list = res.data.data.data;

              this.oms_pending_total = parseFloat(
                res.data.data.data
                  .map((x) => x.amount)
                  .reduce((p, v) => Number(p) + Number(v)) +
                  res.data.data.data
                    .map((x) => x.freighted_charge)
                    .reduce((p, v) => Number(p) + Number(v)),
              );
            }
          })

          .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
              this.is401(error.response.status);
            }
          });
      } catch (err) {
        console.log(err);
      }
    },

    async getRejectedOrders() {
      try {
        let data = this.loadNew({
          status: "REJECTED",
          sub_accountID: this.sub_acct,
          subaccountID: this.$store.getters.sub_acct,
          primary_legal_entity: this.$store.getters.entity,
        });
        await axios({
          method: "get",
          url: this.$hostname + "/rejected-sales-order",
          params: { token: data.cipher },
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
        })
          .then((res) => {
            console.log("res:", res);
            if (res.data.data.data.length > 0) {
              this.isOpenRejected = true;
              this.oms_rejected_list = res.data.data.data;

              this.oms_rejected_total = parseFloat(
                res.data.data.data
                  .map((x) => x.amount)
                  .reduce((p, v) => Number(p) + Number(v)) +
                  res.data.data.data
                    .map((x) => x.freighted_charge)
                    .reduce((p, v) => Number(p) + Number(v)),
              );
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
              this.is401(error.response.status);
            }
          });
      } catch (err) {
        console.log(err);
      }
    },

    async changeModify(x, y) {
      //
      // let sub_acct_bal = Number(this.$store.getters.sub_acct_bal) - (Number(this.oms_pending_total) + Number(this.oms_updated_total));
      // let mbal = oms_order_list[x].order_items

      this.$swal.fire({
        title: "",
        html: this.$preloader,
        showConfirmButton: false,
        showCancelButton: false,
      }); // preloader

      console.log(x, y);
      try {
        let data = this.loadNew({
          id: x,
          status: y,
          subaccountID: this.$store.getters.sub_acct,
          primary_legal_entity: this.$store.getters.entity,
        });

        await axios({
          method: "post",
          url: this.$hostname + "/post-modified-orders",
          data: { token: data.cipher },
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
        })
          .then((res) => {
            this.oms_order_list = [{ order_items: [] }];
            this.getOMSOrders();

            this.fetchAccounts(res.data.message);
          })

          .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
              this.is401(error.response.status);
            }
          });
      } catch (err) {
        console.log(err);
      }
    },

    sortBy(x) {
      this.order_set = x;
      this.theorder = 1;
      this.order_list.sort(function(a, b) {
        var nameA = a[x].toUpperCase(); // ignore upper and lowercase
        var nameB = b[x].toUpperCase(); // ignore upper and lowercase

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });
    },

    reverseSort(x) {
      this.order_set = x;
      this.theorder = 2;
      this.order_list.sort(function(a, b) {
        var nameA = a[x].toUpperCase(); // ignore upper and lowercase
        var nameB = b[x].toUpperCase(); // ignore upper and lowercase

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });

      this.order_list.reverse();
    },

    filterResult() {
      if (this.startdate != "" && this.enddate !== "") {
        this.obj_order.startdate = moment(String(this.startdate)).format(
          "YYYY/MM/DD",
        );
        this.obj_order.enddate = moment(String(this.enddate)).format(
          "YYYY/MM/DD",
        );

        this.getSalesOrders();
        document.getElementById("closebtn").click();
      }
    },

    fetchAccounts(x) {
      this.$swal.fire({
        title: "",
        html: this.$preloader,
        showConfirmButton: false,
        showCancelButton: false,
      }); // preloader

      let data = this.loadNew({
        vendor_no: this.$store.getters.vendor_no,
        primary_legal_entity: this.$store.getters.entity,
      });
      try {
        axios({
          method: "get",
          url: this.$hostname + "/get-accounts-by-legal-entity",
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
          params: { token: data.cipher },
        }).then((res) => {
          if (res.data.status == true) {
            this.$store.commit("set_subaccounts", res.data.data);

            let sub_acct = this.$store.getters.sub_acct;
            let newbal = res.data.data.filter(
              (el) => el.CustomerAccount == sub_acct,
            );
            this.$store.commit("set_sub_acct_bal", newbal[0].CreditRemaining);

            this.subprofiles = this.$store.getters.subaccounts;

            this.$swal.close();
            this.$swal.fire("Success Alert", x, "success");
          }
        });
      } catch (err) {
        console.log(err);
        if (err.response.status === 401) {
          this.is401(err.response.status);
        }
      }
    },

    getSalesOrders() {
      this.obj_order.subaccountID = this.sub_acct;
      this.obj_order.startdate = moment(String(this.startdate)).format(
        "YYYY/MM/DD",
      );
      this.obj_order.enddate = moment(String(this.enddate)).format(
        "YYYY/MM/DD",
      );
      this.obj_order.page = 1;
      this.obj_order.pagesize = 10;
      this.obj_order.linestatus = "";
      this.obj_order.subaccountID = this.$store.getters.sub_acct;
      this.obj_order.primary_legal_entity = this.$store.getters.entity;
      console.log(this.obj_order);
      console.log(this.startdate, this.enddate);

      let data = this.loadNew(this.obj_order);
      try {
        axios({
          method: "get",
          url: this.$hostname + "/get-sale-order-transactions",
          params: { token: data.cipher },
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
        })
          .then((res) => {
            this.order_list = res.data.data;
          })

          .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
              this.is401(error.response.status);
            }
          });
      } catch (err) {
        console.log(err);
        if (err.response.status === 401) {
          this.is401(err.response.status);
        }
      }
    },

    confirmPOD(order) {
      console.log(order, "new see");
      if (confirm("Please confirm that your goods have been delivered")) {
        this.$swal.fire({
          title: "",
          html: this.$preloader,
          showConfirmButton: false,
          showCancelButton: false,
          allowOutsideClick: false,
        });

        this.pod.subaccountID = this.$store.getters.sub_acct;
        this.pod.primary_legal_entity = this.$store.getters.entity;

        // this.pod.saleorderno = orderID;

        this.pod.salesOrderNumber = order.SalesOrderNumber;

        let new_pp = [];
        for (let i = 0; i < order.SalesOrderLines.length; i++) {
          let main_data = {
            lineNumber: order.SalesOrderLines[i].LineNumber,
            itemNo: order.SalesOrderLines[i].ItemNumber,
            damagedQty: order.SalesOrderLines[i].damagedQty,
          };

          console.log("i see each", main_data);

          new_pp.push(main_data);
        }

        console.log(new_pp, "looped data");

        this.pod.damagedInTransitLine = new_pp;

        console.log("test", this.pod);
        console.log(order);

        let data = this.loadNew(this.pod);
        axios({
          method: "post",
          url: this.$hostname + "/submit-pod-order",
          data: { token: data.cipher },
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
        })
          .then((res) => {
            this.response = res.data;
            if (this.response.status == true) {
              // this.getSalesOrders();

              this.$swal.fire(
                "Success Alert",
                this.response.message,
                "success",
              );
            } else {
              this.$swal.fire("Error Alert", this.response.message, "error");
            }
          })
          .catch((error) => {
            console.log(error);
            this.$swal.fire("Error Alert", "Error occured", "error");
            if (error.response.status === 401) {
              this.is401(error.response.status);
            }
          })
          .finally((e) => {
            console.log(e);
          });
      }
      // else{
      //     this.$swal.fire(
      //         'Error Alert',
      //         'Please enter your POD code.',
      //         'error'
      //     );
      // }
    },
  },

  created() {},

  computed: {},
};
</script>

<style scoped>
.card-text {
  color: #5a5555;
}
.card-title {
  font-size: 35px;
}
.card-body.bg-border {
  border: 1px solid #006e40b3;
  box-shadow: none;
}
th.active.up > i.fa-caret-up {
  color: red;
}
th.active.down > i.fa-caret-down {
  color: red;
}
th i {
  font-size: 14px;
}
th i.fa-caret-down {
  right: 9px !important;
  top: 4px;
}
.filter-area {
  padding: 10px;
  background: #ffffff;
  border: 3px solid #006e40;
  margin-bottom: 10px;
  position: fixed;
  z-index: 100;
  right: 40px;
  width: 57px;
  bottom: 40px;
  box-shadow: 0px 1px 20px 1px #0000007d;
}
.modal-dialog {
  max-width: 20%;
  margin: 0 0 0 80%;
}
.modal {
  z-index: 9999;
  width: 100%;
  height: 100%;
}
.modal-content {
  border-radius: 0;
  border: none;
  border-left: 1px solid #dee2e6 !important;
  margin-top: 15%;
}
.modal-title {
  font-size: 19px;
}
.modal-header {
  border-bottom: 1px solid #dee2e638;
}
.border-b {
  border: 2px solid #c1c1c1;
}

.nav-link {
  font-weight: 600;
  color: #000 !important;
  /* padding: 10px 30px; */
}
.nav-tabs {
  border-bottom: 1px solid #dee2e6;
  background: #f7f7f7;
}
.nav-link.active,
.nav-link.active:hover {
  color: #495057;
  border-color: #dee2e6 #dee2e6 #fff !important;
  border-radius: 0;
}
.filter-wrap tbody,
td,
tfoot,
th,
thead,
tr {
  /* text-transform: uppercase; */
}
.table thead th {
  font-weight: 700 !important;
  font-size: 0.785rem;
  /* text-transform: uppercase; */
  /* letter-spacing: .0625rem; */
  padding: 15px 25px !important;
  font-size: 14px !important;
}
.nav-link:hover,
.nav-link:focus {
  border-color: #f7f7f7 #f7f7f7 #dee2e6 #f7f7f7 !important;
}

/* .nav-link.active{ 
    border-bottom: 4px solid #006e40 !important;
    border: none;
    top: 2px;
    border-radius: 3px;
} */

.nav-item {
  margin-right: 10px;
}
/* .nav-tabs {border-bottom: 1px solid #dee2e638;} */

#filterModal2 .modal-dialog,
#filterModal3 .modal-dialog,
#filterModal4 .modal-dialog,
#filterModalInvoiced .modal-dialog,
#filterModalRejected .modal-dialog {
  max-width: calc(100% - 230px) !important;
  /* margin: 0 auto !important; */
  margin-left: calc(250px);
  margin-right: 30px;
}

table td {
  border-bottom: 1px solid #d8d8d8;
  padding: 15px 25px !important;
  font-weight: 600 !important;
}

table {
  counter-reset: rowNumber;
}

table tbody tr {
  counter-increment: rowNumber;
}

table tbody tr td:first-child::before {
  content: counter(rowNumber);
  margin-right: 0.5em;
}

.modal-body {
  overflow-y: scroll;
}
</style>
